var myChart;
function createChart()
{
    //$('#datadriven').append('<canvas id="myChart" width="400" height="400"></canvas>');

    $('#datadriven').append('<div id="myChart" class="ct-chart" width="800" height="800"></div>');


var chart = new Chartist.Pie('.ct-chart', {
  series: [50,40,10],
  labels: ['Desktop', 'Mobile','Pad']
}, {
  donut: true,
  showLabel: true
});

chart.on('draw', function(data) {
  if(data.type === 'slice') {
    // Get the total path length in order to use for dash array animation
    var pathLength = data.element._node.getTotalLength();

    // Set a dasharray that matches the path length as prerequisite to animate dashoffset
    data.element.attr({
      'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
    });

    // Create animation definition while also assigning an ID to the animation for later sync usage
    var animationDefinition = {
      'stroke-dashoffset': {
        id: 'anim' + data.index,
        dur: 1000,
        from: -pathLength + 'px',
        to:  '0px',
        easing: Chartist.Svg.Easing.easeOutQuint,
        // We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
        fill: 'freeze'
      }
    };

    // If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
    if(data.index !== 0) {
      animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
    }

    // We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
    data.element.attr({
      'stroke-dashoffset': -pathLength + 'px'
    });

    // We can't use guided mode as the animations need to rely on setting begin manually
    // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
    data.element.animate(animationDefinition, false);
  }
});

// For the sake of the example we update the chart every time it's created with a delay of 8 seconds
chart.on('created', function() {
  // if(window.__anim21278907124) {
  //   clearTimeout(window.__anim21278907124);
  //   window.__anim21278907124 = null;
  // }
  // window.__anim21278907124 = setTimeout(chart.update.bind(chart), 10000);
});

   // var ctx = document.getElementById("myChart");


// var data = {
//     datasets: [{
//         data: [
//             11,
//             16,
//             7,
//             3,
//             14
//         ],
//         backgroundColor: [
//             "#FF6384",
//             "#4BC0C0",
//             "#FFCE56",
//             "#E7E9ED",
//             "#36A2EB"
//         ],
//         label: 'My dataset' // for legend
//     }],
//     labels: [
//         "Red",
//         "Green",
//         "Yellow",
//         "Grey",
//         "Blue"
//     ]
// };

//     var myChart = new Chart(ctx, {
//     data: data,
//     type: 'polarArea',
//    // options: options
// });

//$('#datadriven canvas').css('width','600px').css('height','600px').css('right','10px').css('position','absolute');

    // var myChart = new Chart(ctx, {
    //     type: 'bar',
    //     data: {
    //         labels: ["Red"],
    //         datasets: [{
    //             label: '# of Votes',
    //             data: [14, 19, 3, 5, 2, 3],
    //             backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)'
    //             ],
    //             borderColor: [
    //             'rgba(255,99,132,1)'
    //             ],
    //             borderWidth: 2
    //         }]
    //     },
    //     options: {
    //         scales: {
    //             yAxes: [{
    //                 ticks: {
    //                     beginAtZero:true
    //                 }
    //             }]
    //         }
    //     }
    // });

}

function destroyChart()
{

}

$(document).ready(function(){

    var wordChangeSpeed = 1000;


    var backgroundSlider = new Swiper ('.header__backgroundSlider', {
        effect:"fade",
    });

    var frontSlider = new Swiper ('.header__frontSlider', {
        loop: true,
        speed:10,
        autoplay:wordChangeSpeed,
        effect:"swipe",
    });

    ////////////////////////////////////////////////////////////////////////////////
    // Slide to previous when that button is clicked
    ////////////////////////////////////////////////////////////////////////////////
    $('body').on('click','#frontSlider__prev',function(){
        frontSlider.slidePrev();
    });
    ////////////////////////////////////////////////////////////////////////////////
    // Slide to next when that button is clicked.
    ////////////////////////////////////////////////////////////////////////////////
    $('body').on('click','#frontSlider__next',function(){
        frontSlider.slideNext();
    });


    ////////////////////////////////////////////////////////////////////////////////
    // Toggle play and paus
    ////////////////////////////////////////////////////////////////////////////////

    $('body').on('click','#frontSlider__togglePausPlay',function(){
        if($(this).hasClass('playing')) {
            frontSlider.stopAutoplay();
            $(this).removeClass('playing');
            $('#frontSlider__paus').fadeOut(200,function(){
                $('#frontSlider__play').fadeIn(200);
            });
            

        } else {
            frontSlider.startAutoplay();
            $(this).addClass('playing');
            $('#frontSlider__play').fadeOut(200,function(){
                $('#frontSlider__paus').fadeIn(200);
            });
            //$('#frontSlider__paus').show();
            //$('#frontSlider__play').hide();
        }

    });

    ////////////////////////////////////////////////////////////////////////////////
    // When hovering the title, paus the slider
    ////////////////////////////////////////////////////////////////////////////////

    $('body').on('mouseenter','.frontSlide__hoverArea',function(e){

        e.preventDefault();
        frontSlider.stopAutoplay();
        // slideToShow = $(this).data('slide');
        // backgroundSlider.slideTo( $(slideToShow).index(),0 );

        // if(slideToShow=='#datadriven') {

        //     createChart();

        // }

    }).on('mouseleave','.frontSlide__hoverArea',function(){
        frontSlider.startAutoplay();
        // backgroundSlider.slideTo( $('#start').index(),0 );
        // $('#myChart').remove();

    });

});
